// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SupplierWiseCurrencyPendingPage_inputContainer__17odU"};